"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailgunTag = void 0;
var MailgunTag;
(function (MailgunTag) {
    MailgunTag["EmailVerification"] = "email-verification";
    MailgunTag["FeedbackRequest"] = "feedback-request";
    MailgunTag["FeedbackCollection"] = "feedback-collection";
    MailgunTag["DriverChanged"] = "driver-changed";
    MailgunTag["VehicleChanged"] = "vehicle-changed";
    MailgunTag["AbandonedCart"] = "abandoned-cart";
    MailgunTag["HigherCar"] = "higher-car";
    MailgunTag["GeneralChanges"] = "general-changes";
    MailgunTag["OrderChanged"] = "order-changed";
    MailgunTag["OrderAccepted"] = "order-accepted";
    MailgunTag["OrderCancelled"] = "order-cancelled";
    MailgunTag["OrderConfirmed"] = "order-confirmed";
    MailgunTag["OrderDeclined"] = "order-declined";
    MailgunTag["OrderMeetingPoint"] = "order-meeting-point";
    MailgunTag["OrderReminder"] = "order-reminder";
    MailgunTag["OrderPickupMissing"] = "order-pickup-missing";
    MailgunTag["MissingFlight"] = "missing-flight";
    MailgunTag["MissingAddress"] = "missing-address";
    MailgunTag["MissingCruise"] = "missing-cruise";
    MailgunTag["MissingTrain"] = "missing-train";
    MailgunTag["ReferralInitial"] = "referral-initial";
    MailgunTag["ReferralNotification"] = "referral-notification";
    MailgunTag["ReferralReferree"] = "referral-referree";
    MailgunTag["ReferralReward"] = "referral-reward";
    MailgunTag["ReferralRewardSent"] = "referral-reward-sent";
    MailgunTag["ReturnTrip"] = "return-trip";
    MailgunTag["TAApproval"] = "TA-approval";
    MailgunTag["TAApprovalWelcomeDiscount"] = "TA-approval-welcome-discount";
    MailgunTag["TAAutoApproval"] = "TA-auto-approval";
    MailgunTag["TAAutoApprovalWelcomeDiscount"] = "TA-auto-approval-welcome-discount";
    MailgunTag["TANoBookings"] = "TA-no-booking";
    MailgunTag["TAFirstBooking"] = "TA-first-booking";
    MailgunTag["TARegistration"] = "TA-registration";
    MailgunTag["TAResetPassword"] = "TA-reset-password";
    MailgunTag["TACommissionSettlement"] = "TA-commission-settlement";
    MailgunTag["TANewBusinessConditions"] = "TA-new-business-conditions";
    MailgunTag["Upselling"] = "upselling";
    MailgunTag["RegistrationEmailVerification"] = "registration-email-verification";
    MailgunTag["PoolAbandonedCart"] = "pool-abandoned-cart";
    MailgunTag["PoolOrderConfirmed"] = "pool-order-confirmed";
    MailgunTag["PasswordReset"] = "password-reset";
    MailgunTag["FailedPreauthorizedPayment"] = "failed-preauthorized-payment";
    MailgunTag["PasswordResetInstructions"] = "password-reset-instructions";
    MailgunTag["Visa50KCampaign"] = "visa-50k-campaign";
    MailgunTag["TripTracking"] = "trip-tracking";
    MailgunTag["OrderOwnChildSeat"] = "order-own-child-seat";
    MailgunTag["CustomTripNotAvailable"] = "custom-trip-not-available";
    MailgunTag["DriverAssignationAccepted"] = "driver-assignation-accepted";
    MailgunTag["DriverAssignationCancelled"] = "driver-assignation-cancelled";
    MailgunTag["DriverAssignationDeclinedAutomatically"] = "driver-assignation-declined-automatically";
    MailgunTag["DriverAssignationDeclinedByDriver"] = "driver-assignation-declined-by-driver";
    MailgunTag["DriverAssignationPending"] = "driver-assignation-pending";
    MailgunTag["DriverDocumentDeclined"] = "driver-document-declined";
    MailgunTag["DriverDeactivated"] = "driver-deactivated";
    MailgunTag["DriverFirstRideAfterThreeMonths"] = "driver-first-ride-after-three-months";
    MailgunTag["DriverFirstRideFeedback"] = "driver-first-ride-feedback";
    MailgunTag["DriverPersonalComboAssignationOffer"] = "driver-personal-combo-assignation-offer";
    MailgunTag["DriverProfilePhotoDeclined"] = "driver-profile-photo-declined";
    MailgunTag["DriverRideAccepted"] = "driver-ride-accepted";
    MailgunTag["DriverRideCancelled"] = "driver-ride-cancelled";
    MailgunTag["DriverRideChanged"] = "driver-ride-changed";
    MailgunTag["DriverRideDeclinedAutomatically"] = "driver-ride-declined-automatically";
    MailgunTag["DriverRideDeclinedByDriver"] = "driver-ride-declined-by-driver";
    MailgunTag["DriverRidePending"] = "driver-ride-pending";
    MailgunTag["DriverStripeAccountOnboardingLink"] = "driver-stripe-account-onboarding-link";
    MailgunTag["DriverUpcomingTripChangeForDriver"] = "driver-upcoming-trip-change-for-driver";
    MailgunTag["DriverUpcomingTripReminderForDriver"] = "driver-upcoming-trip-reminder-for-driver";
})(MailgunTag || (exports.MailgunTag = MailgunTag = {}));
//# sourceMappingURL=MailgunTag.js.map